export default __webpack_public_path__ + "static/media/tailFInHeaderIcon.2b1ca890.svg";